'use client';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { forwardRef, useEffect, useRef, useState } from 'react';
import type { PhoneInputProps, CountryData } from 'react-international-phone';
import { PhoneInput, defaultCountries } from 'react-international-phone';
import './phone-input-styles.css';

export const PhoneInputField = forwardRef(
  ({
    className,
    variant,
    ...props
  }: PhoneInputProps & {
    variant?: 'outlined' | 'default';
  }) => {
    const [focused, setFocused] = useState(false);
    const phoneInputRef = useRef(null);

    const customCountries = defaultCountries.map(country => {
      if (country[1] === 'sk') {
        return ['Slovakia', 'sk', '421', '... ... ...'] as CountryData;
      }
      return country;
    });

    const locale = useLocaleStore(s => s.currentLocale);

    const defaultCountryFromLocale = () => {
      if (locale === 'cs') {
        return 'cz';
      }

      return locale;
    };

    useEffect(() => {
      const handleClickOutside = (event: any) => {
        const current = phoneInputRef.current as any;

        if (current && !current.contains(event.target)) {
          setFocused(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [phoneInputRef]);

    return (
      <div
        ref={phoneInputRef}
        className={cn(
          'rounded-lg',
          focused ? 'outline outline-1 outline-primary' : 'outline-none',
          variant === 'outlined'
            ? 'border-1 border border-border'
            : 'border-1 border border-border',
          className,
        )}
      >
        <PhoneInput
          defaultCountry={defaultCountryFromLocale()}
          name="phone"
          countries={customCountries}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          inputClassName={cn('bg-white')}
          inputStyle={{
            backgroundColor: 'bg-white !important',
            height: '48px !important',
            paddingLeft: '20px',
            width: '100%',
            borderEndEndRadius: 'var(--radius)',
            borderStartEndRadius: 'var(--radius)',
            border: '1px',
          }}
          countrySelectorStyleProps={{
            buttonClassName: 'bg-white',
            buttonStyle: {
              height: '48px !important',
              backgroundColor: 'bg-white !important',
              borderStartStartRadius: 'var(--radius)',
              borderEndStartRadius: 'var(--radius)',
              paddingLeft: '12px',
              border: '1px',
            },
          }}
          {...props}
        />
      </div>
    );
  },
);

PhoneInputField.displayName = 'PhoneInputField';
